import { useTranslation } from 'react-i18next';

import { useUserData } from '../../hooks/useUserData';
import LogoImgColour from '../header/images/colour_mountains.png';
import LogoImg from '../header/images/white_mountains.png';

const CHAMPION_HEALTH = 'Champion Health';

export function LogoLinkButton() {
  const { t } = useTranslation();
  const page = window.location.pathname.split('/')[1];
  const { userData } = useUserData();

  const showCustomName = userData.customFeatureClient?.includes('pam');
  const customName = userData.clientName || CHAMPION_HEALTH;

  return (
    <a href="/">
      <span className="visuallyHidden">{t('nav.link.logo')}</span>
      {page !== 'company' && (
        <img
          src={userData.logo_dark || LogoImg}
          alt={`${showCustomName ? customName : CHAMPION_HEALTH} ${t('logo')}`}
          className="nav-logo"
        />
      )}
      {page === 'company' && (
        <img
          src={userData.logo || LogoImgColour}
          alt={`${showCustomName ? customName : CHAMPION_HEALTH} ${t('logo')}`}
          className="nav-logo"
        />
      )}
    </a>
  );
}
